import api from './api';

export interface PromptConfig {
  name: string;
  description: string;
  template: string;
  variables: string[];
}

export interface PromptsResponse {
  [key: string]: PromptConfig;
}

export const promptsApi = {
  // 获取所有提示词
  getAll: async (): Promise<PromptsResponse> => {
    return await api.get('/prompts');
  },

  // 获取单个提示词
  getOne: async (promptType: string): Promise<PromptConfig> => {
    return await api.get(`/prompts/${promptType}`);
  },

  // 更新提示词
  update: async (promptType: string, updates: Partial<PromptConfig>): Promise<void> => {
    await api.put(`/prompts/${promptType}`, updates);
  },
};
